import { Box, Container } from '@mui/material';

import { OnboardingForm } from '@/features/users/components/onboarding-form';

const OnboardingRoute = () => {
  return (
    <Container maxWidth='sm' sx={{ py: 8 }}>
      <Box sx={{ my: 4 }}>
        <OnboardingForm />
      </Box>
    </Container>
  );
};

export default OnboardingRoute;
